import React from "react";
import { motion } from "framer-motion";
import note from "./ipad 1@2x.png";
import one from "./Vector@x.svg";
import two from "./Vector.svg";
import three from "./Vector@2x.svg";
import { FaDownload } from "react-icons/fa";
import "./Note.css";

const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.25,
      delay: i * 0.08,
      ease: "easeOut"
    }
  })
};

const Note = () => {
  return (
    <div className="container py-5">
      <div className="row row-cols-lg-2 row-cols-1">
        {/* LEFT IMAGE */}
        <motion.div
          className="bubble note col-lg-7 col-12 order-2 order-lg-1"
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{
            opacity: 1,
            scale: 1,
            transition: { duration: 0.3, ease: "easeOut" }
          }}
          viewport={{ once: true }}
        >
          <img className="img-fluid p-sm-5" src={note} alt="" />
          <div className="d-none d-lg-block d-xl-block" id="notes"></div>
        </motion.div>

        {/* RIGHT CONTENT */}
        <motion.div
          className="col-lg-5 col-12 p-4 mt-5 mt-lg-0 order-1 order-lg-2"
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
        >
          <motion.button
            custom={0}
            variants={fadeUp}
            className="notero-button btn mb-3"
          >
            Amar Net Bill App
          </motion.button>

          <motion.h1 custom={1} variants={fadeUp} className="fw-bolder">
            Our Incredible <br />
            <span className="text-color">Features</span>
          </motion.h1>

          <motion.p custom={2} variants={fadeUp}>
            Stay on top of your bills and payments with a clean, easy-to-use
            interface. Track invoices, manage client accounts, and get reminders
            for due payments — everything organized exactly where you need it.
          </motion.p>

          {/* FEATURES */}
          <motion.div
            custom={3}
            variants={fadeUp}
            className="d-flex align-items-center py-3"
          >
            <img src={one} className="me-3" width="40" alt="" />
            <h6>
              Filter bills and invoices using client names, dates, or payment
              status
            </h6>
          </motion.div>

          <motion.div
            custom={4}
            variants={fadeUp}
            className="d-flex align-items-center py-3"
          >
            <img src={two} className="me-3" width="30" alt="" />
            <h6>Automatically sync in real time</h6>
          </motion.div>

          <motion.div
            custom={5}
            variants={fadeUp}
            className="d-flex align-items-center py-3"
          >
            <img src={three} className="me-3" width="40" alt="" />
            <h6>Search and filter bills quickly by client or due date</h6>
          </motion.div>

          {/* BUTTON */}
          <motion.button
            custom={6}
            variants={fadeUp}
            className="downloadBtn rounded-pill"
          >
            <div className="d-flex align-items-center">
              <FaDownload />
              <p className="mt-3 ms-2">Download App</p>
            </div>
          </motion.button>
        </motion.div>
      </div>
    </div>
  );
};

export default Note;
